import {
  CreateGUFStartRegistrationTask,
  EditGUFStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

/**
 * Schema for DesignScreen within a DesignWell
 */
export const designScreenSchema = addSchema<
  NonNullable<
    (
      | CreateGUFStartRegistrationTask
      | EditGUFStartRegistrationTask
    )["sourcedocumentData"]["designInstallations"][number]["designWells"][number]["designScreen"]
  >
>({
  type: "object",
  title: "Filtergegevens",
  required: ["screenType", "designScreenTop", "designScreenBottom"],
  properties: pickGufPrimitiveLibraryFields([
    "screenType",
    "designScreenTop",
    "designScreenBottom",
  ]),
});
